import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import CourseImg from "../../assets/images/user.png";
import Avatar from "../../assets/images/Profile-thumbnail-small.svg";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import { getCourseByIdForStudentCourse } from "../../redux/features/courseSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

export default function CourseDetailStudentTable({
  getCourseDetail,
  totalAssignment,
  instructorId,
}) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchParams] = useSearchParams();
  const [getCourseDetail1, setGetCourseDetail] = useState([]);
  // Ensure valid course array
  const courseList = Array.isArray(getCourseDetail) ? getCourseDetail : [];

  // Pagination logic
  const totalPages = Math.max(1, Math.ceil(courseList.length / rowsPerPage));
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentCourses = getCourseDetail?.slice(startIndex, endIndex);

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle rows per page change
  const handleRowsChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to first page when rows per page changes
  };

  const getCoursesFetchCall = async () => {
    try {
      const res = await dispatch(
        getCourseByIdForStudentCourse({
          token: auth.token,
          courseId: searchParams.get("id"),
        })
      ).unwrap();
      setGetCourseDetail(res?.data?.course);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    getCoursesFetchCall();
  }, []);
  return (
    <>
      {getCourseDetail && getCourseDetail.length > 0 ? (
        <div>
          <div className="d-flex align-item-center justify-content-end d-sm-none">
            <label className="me-2 flex-shrink-0 align-self-center">
              No of Rows
            </label>
            <select
              className="form-control ms-16"
              value={rowsPerPage}
              onChange={handleRowsChange}
              style={{ width: "100px" }}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
            </select>
          </div>
          <div className="table-responsive mb-10">
            <table className="table instructor-course-table custom-table">
              <thead className="position-sticky top-0">
                <tr>
                  <th className="ah-text-base">Sr No.</th>
                  <th className="ah-text-base">Student Name</th>
                  <th className="ah-text-base text-center">Email</th>
                  <th style={{ minWidth: "200px" }} className="ah-text-base">
                    Marks
                  </th>
                  <th className="ah-text-base text-center">Quiz</th>
                  {/* <th className="ah-text-base text-center">Assignment</th> */}
                  <th className="ah-text-base text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentCourses?.length > 0 &&
                  currentCourses.map((course, index) => (
                    <tr key={course.id}>
                      <td>
                        <div className="counter-block">
                          {startIndex + index + 1}
                        </div>
                      </td>
                      <td>
                        <Link
                          to={`/student-details?id=${course.id}`}
                          className="d-flex align-items-center"
                        >
                          <div className="img-holder me-15">
                            <Image
                              src={
                                course?.profile_picture?.startsWith("/")
                                  ? process.env.REACT_APP_GALLERY_URL +
                                    "/" +
                                    course?.profile_picture
                                  : process.env.REACT_APP_GALLERY_URL +
                                    course?.profile_picture
                              }
                              alt={"Instructor"}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = Avatar;
                              }}
                            />
                          </div>
                          <strong className="ah-text-sm fw-semibold text-black">
                            {course.full_name}
                          </strong>
                        </Link>
                      </td>
                      <td className="ah-text-sm text-center fw-medium">
                        {course.email}
                      </td>
                      <td>
                        <div className="progress-bar-holder d-flex align-items-center">
                          <ProgressBar
                            progress={`${course?.marksforStudent || 0}%`}
                          />
                          <div className="d-flex flex-column ms-2">
                            <span className="fw-ah-text-sm fw-medium">
                              {course?.marksforStudent || 0}%
                            </span>
                            {/* <small className="text-muted">
                              {course?.completedQuizzes || 0}Q + {course?.attemptedAssignments || 0}A
                            </small> */}
                          </div>
                        </div>
                      </td>
                      <td className="ah-text-sm text-center fw-medium">
                        <div className="d-flex flex-column align-items-center">
                          <span className={`fw-medium `}>
                            {course?.completedQuizzes || 0} /{" "}
                            {course?.totalQuizzes || 0}
                          </span>
                          {/* {(course?.quizMarks || 0) > 0 && (
                            <small className={`badge ${course?.quizMarks >= 80 ? 'bg-success' : course?.quizMarks >= 60 ? 'bg-warning' : 'bg-danger'} text-white`}>
                              {course?.quizMarks}%
                            </small>
                          )} */}
                          {(course?.completedQuizzes || 0) === 0 &&
                            (course?.totalQuizzes || 0) === 0 && (
                              <small className="text-muted">No quizzes</small>
                            )}
                        </div>
                      </td>
                      <td
                        className={`ah-text-sm text-center fw-semibold ${
                          instructorId === auth.user_id || auth.role === "Admin"
                            ? ""
                            : "disabled-link"
                        }`}
                      >
                        <Link
                          to={`/admin-student-notebook?courseId=${searchParams.get(
                            "id"
                          )}&studentId=${course.id}`}
                        >
                          <svg
                            width="22"
                            height="16"
                            viewBox="0 0 22 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 5C10.2044 5 9.44129 5.31607 8.87868 5.87868C8.31607 6.44129 8 7.20435 8 8C8 8.79565 8.31607 9.55871 8.87868 10.1213C9.44129 10.6839 10.2044 11 11 11C11.7956 11 12.5587 10.6839 13.1213 10.1213C13.6839 9.55871 14 8.79565 14 8C14 7.20435 13.6839 6.44129 13.1213 5.87868C12.5587 5.31607 11.7956 5 11 5ZM11 13C9.67392 13 8.40215 12.4732 7.46447 11.5355C6.52678 10.5979 6 9.32608 6 8C6 6.67392 6.52678 5.40215 7.46447 4.46447C8.40215 3.52678 9.67392 3 11 3C12.3261 3 13.5979 3.52678 14.5355 4.46447C15.4732 5.40215 16 6.67392 16 8C16 9.32608 15.4732 10.5979 14.5355 11.5355C13.5979 12.4732 12.3261 13 11 13ZM11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5Z"
                              fill="#F05203"
                            />
                          </svg>
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {/* Pagination Controls */}
          <div className="d-flex justify-content-center  justify-content-sm-between align-items-center custom-pagination-holder">
            <div className="mx-auto">
              <button
                className="me-2 border-0 bg-transparent p-0"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <svg
                  style={{ transform: "rotate(-90deg)" }}
                  width="12"
                  height="10"
                  viewBox="0 0 17 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Prev
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i + 1}
                  className={`bg-transparent border-0 ${
                    currentPage === i + 1
                      ? "pagination-item active"
                      : "pagination-item"
                  } me-2`}
                  onClick={() => handlePageChange(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button
                className="me-2 border-0 bg-transparent p-0"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
                <svg
                  style={{ transform: "rotate(90deg)" }}
                  width="12"
                  height="10"
                  viewBox="0 0 17 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* Rows per page selector */}
            <div className="align-item-center d-none d-sm-flex">
              <label className="me-2 flex-shrink-0 align-self-center">
                No of Rows
              </label>
              <select
                className="form-control ms-16"
                value={rowsPerPage}
                onChange={handleRowsChange}
                style={{ width: "100px" }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={40}>40</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>
        </div>
      ) : (
        <div className="alert alert-info">No Enrolled Students</div>
      )}
    </>
  );
}
